export class Header {
	constructor() {
		this.container = document.querySelector('.header');
		this.burger = this.container.querySelector('.header-burger');
		this.megamenu = document.querySelector('.megaMenu');
		this.megamenuClose = this.megamenu.querySelector('.megaMenu-close');
	}

	init() {
		this.addEvents();

		this.changeBackground();
	}

	addEvents() {
		this.megamenu
			.querySelectorAll('.menu-item-has-children > a')
			.forEach((anchor) => {
				anchor.addEventListener('click', (event) => {
					event.preventDefault();

					const item = anchor.closest('.menu-item-has-children');

					this.toggleSubmenu(item);
				});
			});

		this.burger.addEventListener('click', () => {
			this.openMegaMenu();
		});

		this.megamenuClose.addEventListener('click', () => {
			this.closeMegaMenu();
		});

		this.megamenu.addEventListener('transitionend', () => {
			if (this.megamenu.classList.contains('active')) {
				this.showLinkMenu();
			} else {
				this.megamenu.querySelectorAll('.show').forEach((item) => {
					item.classList.remove('show');
				});
			}
		});

		this.megamenu
			.querySelector('.megaMenu-nav .menu-item:last-child')
			.addEventListener('transitionend', () => {
				this.showRightMegaMenu();
			});

		window.addEventListener('scroll', this.changeBackground.bind(this));
		window.addEventListener('scroll', this.onScroll.bind(this));
	}

	onScroll() {
		let prevScrollTop =
			window.scrollY || document.documentElement.scrollTop;
		let prevScrollDirection = '';

		window.addEventListener(
			'scroll',
			() => {
				const st = window.scrollY || document.documentElement.scrollTop;
				if (st > prevScrollTop && prevScrollDirection !== 'down') {
					this.hideMenu();
					prevScrollDirection = 'down';
				} else if (st < prevScrollTop && prevScrollDirection !== 'up') {
					this.showMenu();
					prevScrollDirection = 'up';
				}
				prevScrollTop = st <= 0 ? 0 : st; // for Mobile or negative scrolling
			},
			false
		);
	}

	hideMenu() {
		if (!this.container.classList.contains('hidden')) {
			this.container.classList.add('hidden');
		}
	}

	showMenu() {
		if (this.container.classList.contains('hidden')) {
			this.container.classList.remove('hidden');
		}
	}

	toggleSubmenu(item) {
		const submenu = item.querySelector('.sub-menu');
		const height = [...item.querySelectorAll('li')].reduce(
			(acc, li) => acc + li.getBoundingClientRect().height,
			0
		);

		submenu.style.height =
			submenu.offsetHeight === 0 ? `${height}px` : '0px';

		if (submenu.offsetHeight === 0) {
			item.classList.add('open');
		} else {
			item.classList.remove('open');
		}
	}

	openMegaMenu() {
		this.megamenu.classList.add('active');
	}

	closeMegaMenu() {
		this.megamenu.classList.remove('active');
	}

	showLinkMenu() {
		this.megamenu
			.querySelectorAll('.megaMenu-nav .menu-item, .megaMenu-langButton')
			.forEach((item, index) => {
				item.style.transitionDelay = index * 0.05 + 's';
				item.classList.add('show');
			});
	}

	showRightMegaMenu() {
		this.megamenu
			.querySelectorAll('.megaMenu-right > div')
			.forEach((item, index) => {
				item.style.transitionDelay = index * 0.05 + 's';
				item.classList.add('show');
			});
	}

	changeBackground() {
		const scroll = window.scrollY;

		if (scroll > 10) {
			this.container.classList.add('backWhite');
		} else {
			this.container.classList.remove('backWhite');
		}
	}
}
